export default "__VITE_ASSET__DmGBP$3o__"